class R36ProductExperience extends HTMLElement {
  connectedCallback() {
    const dataNode = this.querySelector('[data-r36-json]');
    if (!dataNode) return;

    this.data = JSON.parse(dataNode.textContent);
    if (!this.data.variants?.length) return;
    // Canonical selection values keep the selector independent of Shopify translations.
    const ui = this.data.ui;
    const colors = { [ui.white]: 'Blanc', [ui.black]: 'Noir', [ui.blue]: 'Bleu', [ui.purple]: 'Violet', [ui.yellow]: 'Jaune', [ui.red]: 'Rouge', [ui.green]: 'Vert' };
    this.data.optionNames = this.dataset.model === 'ultra' ? ['Version', 'Coloris', 'Stockage'] : ['Coloris', 'Stockage'];
    this.data.variants.forEach(variant => {
      variant.options = variant.options.map((value, index) => {
        const type = this.data.optionNames[index];
        if (type === 'Version') return value.includes('Ultra X') ? '4,5 pouces (Ultra X)' : '4 pouces';
        if (type === 'Coloris') return colors[value] || value;
        if (type === 'Stockage') return value.includes('128') ? '128GB' : '64GB';
        return value;
      });
    });


    this.form = this.querySelector('.r36xp__form');
    this.idInput = this.querySelector('[data-r36-variant-id]');
    this.optionsRoot = this.querySelector('[data-r36-options]');
    this.priceTargets = this.querySelectorAll('[data-r36-price]');
    this.summaryTargets = this.querySelectorAll('[data-r36-summary]');
    this.buttons = this.querySelectorAll('[data-r36-submit]');

    const queryId = new URL(window.location.href).searchParams.get('variant');
    const initialVariant = this.data.variants.find((variant) => String(variant.id) === queryId)
      || this.data.variants.find((variant) => String(variant.id) === String(this.data.initialVariantId))
      || this.data.variants.find((variant) => variant.available)
      || this.data.variants[0];

    this.selected = [...initialVariant.options];
    this.withPack = false;
    this.renderOptions();
    this.bindBundle();
    this.updateVariant({ updateUrl: false });
    this.bindGallery();
    this.bindStickyBar();
    this.querySelectorAll('[data-r36-select-version]').forEach(link => {
      link.addEventListener('click', () => {
        const index = this.data.optionNames.findIndex(name => name.toLowerCase().includes('version'));
        if (index < 0) return;
        this.selected[index] = link.dataset.r36SelectVersion;
        this.reconcileSelection(index);
        this.updateVariant();
      });
    });
  }

  renderOptions() {
    if (!this.optionsRoot) return;
    const hidden = new Set(this.data.hiddenOptions || []);

    this.data.optionNames.forEach((name, optionIndex) => {
      if (hidden.has(name)) return;
      const values = [...new Set(this.data.variants.map((variant) => variant.options[optionIndex]))];
      const fieldset = document.createElement('fieldset');
      const isVersion = name.toLowerCase().includes('version');
      const isColor = name.toLowerCase().includes('color');
      const isStorage = name.toLowerCase().includes('stockage');
      fieldset.className = 'r36xp__option' + (isVersion ? ' r36xp__option--version' : isColor ? ' r36xp__option--color' : isStorage ? ' r36xp__option--storage' : '');
      const legend = document.createElement('legend');
      legend.textContent = isVersion ? this.data.ui.ui_model : isStorage ? this.data.ui.ui_storage : this.data.ui.ui_color;
      legend.dataset.step = String(optionIndex + 1).padStart(2, '0');
      fieldset.append(legend);

      const list = document.createElement('div');
      list.className = name.toLowerCase().includes('color') ? 'r36xp__choices r36xp__choices--colors' : 'r36xp__choices';

      values.forEach((value, valueIndex) => {
        const id = `${this.id}-${optionIndex}-${valueIndex}`;
        const wrap = document.createElement('div');
        wrap.className = 'r36xp__choice';
        const input = document.createElement('input');
        input.type = 'radio';
        input.id = id;
        input.name = `${this.id}-${name}`;
        input.value = value;
        input.setAttribute('aria-label', this.displayValue(value));
        input.dataset.optionIndex = String(optionIndex);
        input.addEventListener('change', () => {
          this.selected[optionIndex] = value;
          this.reconcileSelection(optionIndex);
          this.updateVariant({ resetGallery: isColor || isVersion });
        });

        const label = document.createElement('label');
        label.htmlFor = id;
        if (name.toLowerCase().includes('color')) {
          const dot = document.createElement('span');
          dot.className = 'r36xp__dot';
          dot.style.setProperty('--dot', this.colorValue(value));
          label.append(dot);
        }
        const text = document.createElement('span');
        text.className = 'r36xp__choice-copy';
        if (isVersion) {
          const photo = document.createElement('img');
          photo.src = this.data.galleries[value].hero.src;
          photo.alt = '';
          photo.width = 240;
          photo.height = 160;
          const title = document.createElement('strong');
          title.textContent = value.includes('Ultra X') ? 'Ultra X' : 'Ultra';
          const detail = document.createElement('small');
          detail.textContent = value.includes('Ultra X') ? this.data.ui.ui_wide : this.data.ui.ui_square;
          const price = document.createElement('span');
          price.className = 'r36xp__choice-price';
          price.dataset.versionPrice = value;
          text.append(title, detail, price);
          label.append(photo);
        } else if (isStorage) {
          const title = document.createElement('strong');
          title.textContent = this.displayValue(value);
          const detail = document.createElement('small');
          detail.textContent = value.includes('128') ? this.data.ui.ui_space : this.data.ui.ui_library;
          const extra = document.createElement('span');
          extra.className = 'r36xp__choice-extra';
          extra.dataset.storageExtra = value;
          text.append(title, detail, extra);
        } else {
          text.textContent = this.displayValue(value);
        }
        label.append(text);
        wrap.append(input, label);
        list.append(wrap);
      });

      fieldset.append(list);
      this.optionsRoot.append(fieldset);
    });
  }

  displayValue(value) {
    const ui = this.data.ui;
    const labels = { Blanc: ui.white, Noir: ui.black, Bleu: ui.blue, Violet: ui.purple, Jaune: ui.yellow, Rouge: ui.red, Vert: ui.green,
      '4 pouces': ui.size_u, '4,5 pouces (Ultra X)': 'Ultra X · ' + ui.size_x };
    return labels[value] || value.replace('GB', ' ' + ui.unit);
  }

  colorValue(value) {
    const colors = {
      Blanc: 'oklch(92% .01 302)', Noir: 'oklch(18% .02 302)',
      Bleu: 'oklch(55% .16 245)', Violet: 'oklch(56% .2 302)',
      Jaune: 'oklch(80% .15 95)', Rouge: 'oklch(55% .2 25)',
      Vert: 'oklch(58% .14 145)'
    };
    return colors[value] || 'oklch(60% .03 302)';
  }

  currentVariant() {
    return this.data.variants.find((variant) => variant.options.every((option, index) => option === this.selected[index]));
  }

  reconcileSelection(changedIndex) {
    if (this.currentVariant()) return;

    const candidates = this.data.variants.filter((variant) => variant.options[changedIndex] === this.selected[changedIndex]);
    if (!candidates.length) return;

    const score = (variant) => variant.options.reduce((total, option, index) => {
      if (index === changedIndex) return total;
      return total + (option === this.selected[index] ? 2 : 0) + (variant.available ? 1 : 0);
    }, 0);
    const best = [...candidates].sort((a, b) => score(b) - score(a))[0];
    this.selected = [...best.options];
  }

  syncOptionInputs() {
    this.querySelectorAll('.r36xp__choice input').forEach((input) => {
      const optionIndex = Number(input.dataset.optionIndex);
      input.checked = input.value === this.selected[optionIndex];

      const optionName = this.data.optionNames[optionIndex].toLowerCase();
      const isVersion = optionName.includes('version');
      input.disabled = !this.data.variants.some((variant) => {
        if (variant.options[optionIndex] !== input.value) return false;
        return variant.options.every((option, index) => {
          if (index === optionIndex) return true;
          if (isVersion && this.data.optionNames[index].toLowerCase().includes('color')) return true;
          return option === this.selected[index];
        });
      });
    });
  }

  updateVariant({ updateUrl = true, resetGallery = false } = {}) {
    const variant = this.currentVariant();
    this.syncOptionInputs();

    const visibleValues = this.selected.filter((value, index) => !this.data.hiddenOptions.includes(this.data.optionNames[index]));
    this.summaryTargets.forEach((node) => { node.textContent = visibleValues.map((value) => this.displayValue(value)).join(' · '); });

    if (!variant) {
      if (this.idInput) {
        this.idInput.value = '';
        this.idInput.disabled = true;
      }
      this.priceTargets.forEach((node) => { node.textContent = this.data.ui.soldout; });
      this.setSubmitState(false, this.data.ui.ui_unavailable);
      return;
    }

    if (this.idInput) {
      this.idInput.value = variant.id;
      this.idInput.disabled = false;
    }
    this.updateBundle(variant);
    const versionIndex = this.data.optionNames.findIndex(name => name.toLowerCase().includes('version'));
    const storageIndex = this.data.optionNames.findIndex(name => name.toLowerCase().includes('stockage'));
    this.querySelectorAll('[data-version-price]').forEach(node => {
      const match = this.data.variants.find(candidate => candidate.options[versionIndex] === node.dataset.versionPrice && candidate.options[storageIndex] === this.selected[storageIndex]);
      node.textContent = match ? this.formatPrice(match) : '';
    });
    const base = this.data.variants.find(candidate => candidate.options.every((option, index) => index === storageIndex ? option === '64GB' : option === this.selected[index]));
    this.querySelectorAll('[data-storage-extra]').forEach(node => {
      const match = this.data.variants.find(candidate => candidate.options.every((option, index) => index === storageIndex ? option === node.dataset.storageExtra : option === this.selected[index]));
      const difference = match && base ? match.price - base.price : 0;
      node.textContent = difference > 0 ? '+ ' + this.formatPrice({ price: difference }) : this.data.ui.ui_included;
    });
    this.querySelectorAll('.r36xp__option--color .r36xp__choice').forEach(choice => { choice.hidden = choice.querySelector('input').disabled; });
    this.setSubmitState(variant.available, variant.available ? this.data.ui.add : this.data.ui.soldout);
    this.updatePresentation(variant, { resetGallery });

    if (updateUrl && window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  formatPrice(variant) {
    if (!Number.isFinite(variant.price)) return variant.priceFormatted || '';
    return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
      style: 'currency', currency: this.data.currency || 'EUR'
    }).format(variant.price / 100);
  }

  setSubmitState(enabled, labelText) {
    this.buttons.forEach((button) => {
      button.disabled = !enabled || this.busy;
      const label = button.querySelector('[data-r36-submit-label]');
      if (label) label.textContent = this.busy ? this.data.bundle.adding : enabled && this.withPack ? this.data.bundle.add : labelText;
    });
  }

  bindBundle() {
    const bundle = this.querySelector('[data-r36-bundle]');
    if (bundle) bundle.hidden = false;
    this.querySelectorAll('input[name="r36-offer"]').forEach(input => {
      input.addEventListener('change', () => {
        const variant = this.currentVariant();
        const pack = this.bundleForVariant(variant);
        this.withPack = input.value === 'pack' && Boolean(pack?.available);
        this.updateVariant({ updateUrl: false });
      });
    });
    this.form?.addEventListener('submit', event => {
      event.preventDefault();
      this.addToCart();
    });
  }

  bundleForVariant(variant) {
    if (!variant) return null;
    if (this.dataset.model === 'r36h') return this.data.bundle.r36h;
    const versionIndex = this.data.optionNames.indexOf('Version');
    const version = versionIndex >= 0 ? variant.options[versionIndex] : '';
    return version.includes('Ultra X') ? this.data.bundle.ultrax : this.data.bundle.ultra;
  }

  updateBundle(variant) {
    const pack = this.bundleForVariant(variant);
    const packAvailable = Boolean(pack?.available && pack?.id);
    const packInput = this.querySelector('input[value="pack"]');
    const soloInput = this.querySelector('input[value="solo"]');
    const packChoice = this.querySelector('[data-r36-pack-choice]');
    if (packInput) packInput.disabled = !packAvailable;
    if (packChoice) packChoice.classList.toggle('is-unavailable', !packAvailable);
    if (!packAvailable && this.withPack) {
      this.withPack = false;
      if (soloInput) soloInput.checked = true;
    }
    const packPrice = pack?.price || 0;
    const total = variant.price + (this.withPack ? packPrice : 0);
    this.priceTargets.forEach(node => { node.textContent = this.formatPrice({ price: total }); });
    this.querySelectorAll('[data-r36-total]').forEach(node => { node.textContent = this.formatPrice({ price: total }); });
    this.querySelectorAll('[data-r36-solo-price]').forEach(node => { node.textContent = this.formatPrice(variant); });
    this.querySelectorAll('[data-r36-pack-price]').forEach(node => { node.textContent = packAvailable ? this.formatPrice({ price: variant.price + packPrice }) : this.data.ui.ui_unavailable; });
    this.querySelectorAll('[data-r36-pack-detail]').forEach(node => {
      node.innerHTML = packAvailable
        ? `${this.escapeHtml(this.data.bundle.detail)} <span>+ ${this.escapeHtml(this.formatPrice({ price: packPrice }))}</span>`
        : this.escapeHtml(this.data.bundle.unavailable);
    });
    this.querySelectorAll('[data-r36-pack-photo]').forEach(image => {
      if (pack?.image) image.src = pack.image;
    });
    const count = this.querySelector('[data-r36-bundle-count]');
    if (count) count.textContent = this.withPack ? this.data.bundle.two : this.data.bundle.one;
    const versionIndex = this.data.optionNames.indexOf('Version');
    const gallery = this.data.galleries[variant.options[versionIndex]] || this.data.galleries.default;
    this.querySelectorAll('[data-r36-bundle-console]').forEach(image => {
      image.src = variant.featuredImage || gallery.hero.src;
    });
  }

  escapeHtml(value) {
    const node = document.createElement('span');
    node.textContent = value || '';
    return node.innerHTML;
  }

  async addToCart() {
    const variant = this.currentVariant();
    if (this.busy || !variant?.available) return;
    const error = this.querySelector('.product-form__error-message-wrapper');
    if (error) error.hidden = true;
    this.busy = true;
    this.form.setAttribute('aria-busy', 'true');
    const controls = [...this.form.querySelectorAll('input[type="radio"]')];
    const previous = controls.map(input => input.disabled);
    controls.forEach(input => { input.disabled = true; });
    this.setSubmitState(false, this.data.bundle.adding);
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const root = window.Shopify?.routes?.root || '/';
    const items = [{ id: variant.id, quantity: 1 }];
    const pack = this.bundleForVariant(variant);
    if (this.withPack && pack?.available && pack?.id) items.push({ id: pack.id, quantity: 1 });
    const payload = { items };
    if (cart?.getSectionsToRender) {
      payload.sections = cart.getSectionsToRender().map(section => section.id);
      payload.sections_url = window.location.pathname;
      cart.setActiveElement?.(document.activeElement);
    }
    let added = false;
    try {
      // Request objects avoid third-party string-URL interceptors that may retry POSTs.
      const response = await fetch(new Request(window.location.origin + root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }));
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.data.bundle.error);
      added = true;
      const homeCart = document.querySelector('moonbundle-cart-drawer-block');
      if (typeof homeCart?.open === 'function') homeCart.open(true);
      else {
        if (cart?.renderContents && result.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else window.location.assign(root + 'cart');
      }
    } catch (failure) {
      // A drawer-render failure must never invite a duplicate add.
      if (added) window.location.assign(root + 'cart');
      else if (error) {
        error.hidden = false;
        error.querySelector('.product-form__error-message').textContent = failure instanceof TypeError ? this.data.bundle.error : failure.message || this.data.bundle.error;
      }
    } finally {
      this.busy = false;
      this.form.removeAttribute('aria-busy');
      controls.forEach((input, index) => { input.disabled = previous[index]; });
      this.setSubmitState(variant.available, this.data.ui.add);
    }
  }

  updatePresentation(variant, { resetGallery = false } = {}) {
    const versionIndex = this.data.optionNames.findIndex((name) => name.toLowerCase().includes('version'));
    const colorIndex = this.data.optionNames.findIndex((name) => name.toLowerCase().includes('color'));
    const version = versionIndex >= 0 ? variant.options[versionIndex] : 'default';
    const color = colorIndex >= 0 ? variant.options[colorIndex] : '';
    const specs = this.data.specs?.[version];
    if (specs) {
      Object.entries(specs).forEach(([key, value]) => {
        this.querySelectorAll(`[data-r36-spec="${key}"]`).forEach((node) => { node.textContent = value; });
      });
      const note = this.querySelector('[data-r36-photo-note]');
      if (note) note.textContent = specs.photoNote;
      const versionLabel = this.querySelector('[data-r36-version-label]');
      if (versionLabel) versionLabel.textContent = specs.version;
    }

    const gallery = this.data.galleries?.[version] || this.data.galleries?.default;
    if (!gallery) return;
    this.querySelectorAll('[data-r36-thumb]').forEach((thumb) => {
      const image = gallery[thumb.dataset.view];
      if (!image) return;
      thumb.dataset.src = image.src;
      thumb.dataset.alt = image.alt;
      thumb.dataset.caption = image.caption;
      const thumbImage = thumb.querySelector('img');
      if (thumbImage) thumbImage.src = image.src;
    });

    const heroThumb = this.querySelector('[data-r36-thumb][data-view="hero"]');
    if (heroThumb && variant.featuredImage) {
      const alt = [this.data.productLabel, color ? this.displayValue(color) : ''].filter(Boolean).join(' · ');
      heroThumb.dataset.src = variant.featuredImage;
      heroThumb.dataset.alt = alt;
      heroThumb.dataset.caption = alt;
      const heroImage = heroThumb.querySelector('img');
      if (heroImage) heroImage.src = variant.featuredImage;
      const note = this.querySelector('[data-r36-photo-note]');
      if (note) note.textContent = alt;
    }

    const activeThumb = resetGallery && heroThumb
      ? heroThumb
      : this.querySelector('[data-r36-thumb][aria-current="true"]') || heroThumb || this.querySelector('[data-r36-thumb]');
    if (activeThumb) this.showGalleryImage(activeThumb);
    this.querySelectorAll('[data-r36-dynamic-view]').forEach((imageNode) => {
      const image = gallery[imageNode.dataset.r36DynamicView];
      if (!image) return;
      imageNode.src = image.src;
      imageNode.alt = image.alt;
    });
  }

  showGalleryImage(thumb) {
    const main = this.querySelector('[data-r36-main-image]');
    const caption = this.querySelector('[data-r36-caption]');
    if (!main || !caption) return;
    main.src = thumb.dataset.src;
    main.alt = thumb.dataset.alt;
    caption.textContent = thumb.dataset.caption;
    this.querySelectorAll('[data-r36-thumb]').forEach((item) => item.setAttribute('aria-current', String(item === thumb)));
  }

  bindGallery() {
    this.querySelectorAll('[data-r36-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => this.showGalleryImage(thumb));
    });
  }

  bindStickyBar() {
    // 07/10/2026 : barre d'achat mobile (<= 749 px). Visible dès que le bouton d'achat natif est hors écran
    // (avant comme après lui), vignette = image déjà chargée par la galerie, posée au-dessus de la bannière cookies.
    const bar = this.querySelector('[data-r36-sticky]');
    const native = this.querySelector('[data-r36-purchase] [data-r36-submit]');
    if (!bar || !native || !('IntersectionObserver' in window)) return;
    const mobile = window.matchMedia('(max-width: 749px)');
    const heroImage = this.querySelector('[data-r36-thumb][data-view="hero"] img');
    if (heroImage && !bar.querySelector('.r36xp__sticky-thumb')) {
      const thumb = document.createElement('img');
      thumb.className = 'r36xp__sticky-thumb';
      thumb.alt = '';
      thumb.width = 44;
      thumb.height = 44;
      thumb.decoding = 'async';
      thumb.src = heroImage.src;
      bar.prepend(thumb);
      new MutationObserver(() => { thumb.src = heroImage.src; }).observe(heroImage, { attributes: true, attributeFilter: ['src'] });
    }
    let nativeInView = true;
    const sync = () => {
      const show = mobile.matches && !nativeInView;
      bar.classList.toggle('is-visible', show);
      bar.toggleAttribute('inert', !show);
      bar.setAttribute('aria-hidden', String(!show));
    };
    new IntersectionObserver(([entry]) => { nativeInView = entry.isIntersecting; sync(); }).observe(native);
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    const consent = document.getElementById('r36s-cc');
    if (!consent) return;
    const lift = () => {
      const shown = getComputedStyle(consent).display !== 'none';
      const height = shown ? Math.max(0, Math.round(window.innerHeight - consent.getBoundingClientRect().top)) : 0;
      bar.style.setProperty('--r36-sticky-offset', height + 'px');
      bar.toggleAttribute('data-cc-lifted', height > 0);
    };
    lift();
    if ('ResizeObserver' in window) new ResizeObserver(lift).observe(consent);
    new MutationObserver(lift).observe(consent, { attributes: true });
    new MutationObserver(lift).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', lift, { passive: true });
  }
}

if (!customElements.get('r36-product-experience')) {
  customElements.define('r36-product-experience', R36ProductExperience);
}
